import { skipToken, useQuery } from '@tanstack/react-query'
import { useApiClient } from '@chilipiper/api-client/src/context'

export const useGroupSchedulingLinkById = ({
  tenantId,
  groupLinkId,
  enabled = true,
}: {
  tenantId?: string
  groupLinkId?: string
  enabled?: boolean
}) => {
  const { teamSchedulingV2 } = useApiClient()
  return useQuery({
    queryKey: [tenantId, groupLinkId, 'team-scheduling/find-group-scheduling-by-link-id'],
    queryFn:
      tenantId && groupLinkId
        ? () =>
            teamSchedulingV2.findAGroupSchedulingLinkByGroupSchedulingLinkIdPublicV2(
              tenantId,
              groupLinkId
            )
        : skipToken,
    enabled,
  })
}

export const useSchedulingLink = ({
  tenantId,
  schedulingLinkSlug,
  hostId,
  schedulingLinkId,
  enabled = true,
}: {
  tenantId?: string
  schedulingLinkId?: string
  schedulingLinkSlug?: string
  hostId?: string
  enabled?: boolean
}) => {
  const { teamScheduling } = useApiClient()
  const schedulingKey = schedulingLinkSlug ?? schedulingLinkId
  return useQuery({
    queryKey: [tenantId, schedulingKey, 'team-scheduling/get-scheduling-link'],
    queryFn:
      tenantId && schedulingKey
        ? () => {
            if (schedulingLinkSlug && hostId) {
              return teamScheduling.findAAdminSchedulingLinkBySlug(tenantId, schedulingLinkSlug, {
                hostId,
              })
            }

            if (schedulingLinkId) {
              return teamScheduling.findAAdminSchedulingLinkByAdminSchedulingLinkIdPublic(
                tenantId,
                schedulingLinkId
              )
            }

            return Promise.resolve(null)
          }
        : skipToken,
    retry: 3,
    enabled,
  })
}
